import UtmLink from '@/components/shared/UtmLink'
import CTAButton from '@/components/shared/CTAButton'
import { vehicleMakes } from '@/utils/vehicleData'

const VehicleLinksSection = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  return (
    <section className="py-12 md:py-16">
      <div className="container mx-auto max-w-6xl px-4">
        <h2 className="text-foreground mb-6 text-3xl font-bold">
          Claim Mis-sold Car Finance By Vehicle Make
        </h2>

        <p className="text-foreground mb-8 text-lg leading-relaxed">
          We process claims for all major vehicle makes. You could be owed
          thousands in compensation, so don&apos;t miss the opportunity to check
          your eligibility.
        </p>

        <div className="mb-8 grid grid-cols-2 gap-4 md:grid-cols-4">
          {vehicleMakes.map(vehicle => (
            <UtmLink
              key={vehicle.url}
              to={vehicle.url}
              onClick={scrollToTop}
              className="bg-card border-foreground group rounded-lg border-2 p-4 text-center transition-all duration-300 hover:scale-105 hover:shadow-lg"
            >
              <span className="text-foreground font-semibold">
                {vehicle.name}
              </span>
            </UtmLink>
          ))}
        </div>

        <div className="text-center">
          <CTAButton />
        </div>
      </div>
    </section>
  )
}

export default VehicleLinksSection
